import { useEffect, useState } from 'react';

import { DateRangePreset } from '../../../../../shared/constants/dateRangePreset';
import { getDateRangeByPreset } from '../../../../../shared/utils/getDateRangeByPreset/getDateRangeByPreset';
import { BestSellingResponse } from '../../../../interfaces/entity-dashboard/BestSellingResponse';
import { entityDashboardService } from '../../../../services/entityDashboardService';
import { SolutionTypeFilter } from '../../../../../shared/constants/user-info/solutionType';

type UseBestSellingDataParams = {
  dateRangePreset: DateRangePreset;
  solutionTypeFilter: SolutionTypeFilter;
  itemCount: number;
};

type UseBestSellingDataReturn = {
  bestSellingData: BestSellingResponse;
};

export const useBestSellingData = ({
  dateRangePreset,
  solutionTypeFilter,
  itemCount,
}: UseBestSellingDataParams): UseBestSellingDataReturn => {
  const [bestSellingData, setBestSellingData] = useState<BestSellingResponse>([]);

  const fetchBestSellingData = async () => {
    const dateRange = getDateRangeByPreset(dateRangePreset);

    const data = await entityDashboardService.getBestSelling({
      ...dateRange,
      solutionType: solutionTypeFilter,
      itemCount,
    });

    setBestSellingData(data);
  };

  useEffect(() => {
    fetchBestSellingData();
  }, [dateRangePreset, solutionTypeFilter, itemCount]);

  return { bestSellingData };
};
